import gql from 'graphql-tag'

export const mediaAttrsFragment = gql`
  fragment mediaAttrs on Media {
    __typename
    noteId
    url
    name
    meta
    createdAt
    createdBy
  }
`

const MediaAPI = {
  createNoteMedia: gql`
    mutation createNoteMedia($media: NoteMediaCreationInput!) {
      createNoteMedia(media: $media) {
        ...mediaAttrs
      }
    }
    ${mediaAttrsFragment}
  `,
}

export default MediaAPI
